import { url2link } from '@/js/_common';

const main = () => {
    if (document.querySelector('#page-user-profile-show') == null) return
    url2link('.p-profile__text');
    // クリップボードにURLをコピー
    document.querySelector('.p-links__item[data-type="url"] a').addEventListener('click', (e) => {
        e.preventDefault()
        const url = e.currentTarget.getAttribute('href')
        const parent = e.currentTarget.closest('.p-links__item')
        navigator.clipboard.writeText(url).then(
            () => {
                parent.classList.add('copied')
                setTimeout(() => {
                    parent.classList.remove('copied')
                }, 2000)
            });
        return false
    });
}

export default main;
